module.exports = __webpack_public_path__ + "img/icon_4-1.a78e1d77.png";